import { TextField } from '@mui/material';
import { createCustomerPageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { useFormContext } from 'react-hook-form';
import { NewCustomer, UpdateCustomer } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';

export const NetSuiteLegacyInput = () => {
  const { getValues, register, formState, setValue } = useFormContext<NewCustomer | UpdateCustomer>();

  const legacyErpId = getValues('erpMetadata')?.erpId;
  const onManualErpIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const erpId = event.target.value;

    setValue('erpMetadata', { erpId, erpName: 'NetSuite Customer' }, { shouldDirty: true });
  };

  return (
    <TextField
      {...getSelectorAttribute(createCustomerPageSelectors.configuration.erpId)}
      label="ERP ID"
      {...register('erpMetadata.erpId')}
      onChange={onManualErpIdChange}
      defaultValue={legacyErpId}
      fullWidth
      error={isNotNullOrUndefined(formState.errors.erpMetadata?.erpId)}
      helperText={formState.errors.erpMetadata?.erpId?.message}
    />
  );
};
